// Top Section Animated Dots
//- About Video Dots Animation
let num = 0;
function timeoutDotsAnimation() {
    setTimeout(function () {
        const el = $('#aboutProductBanner .about-product__item');
        // console.log('num', num);

        (num === 4) ? num = 1 : num++;

        el.removeClass('about-product__item--anim');
        $('#aboutProductBanner .about-product__item[data-num=' + num + ']').addClass('about-product__item--anim');
        timeoutDotsAnimation();
    }, 3000);
}

timeoutDotsAnimation();